"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountInfo = void 0;
const tslib_1 = require("tslib");
const qb = tslib_1.__importStar(require("./qb"));
const type_1 = require("./type");
/**
 * 调用QBAPI去获取登录态
 */
exports.getAccountInfo = () => {
    var _a;
    if ((_a = qb.getBrowser()) === null || _a === void 0 ? void 0 : _a.getAccountInfo) {
        return new Promise((resolve, reject) => {
            const success = (res) => {
                resolve({
                    code: type_1.UserErrCode.OK,
                    msg: 'ok',
                    data: res,
                });
            };
            const failed = () => {
                reject({
                    code: type_1.UserErrCode.ERR_JSAPI_FAILED,
                    msg: 'jsapi invoke failed',
                });
            };
            qb.getBrowser().login.getAccountInfo(success, failed);
        });
    }
    return Promise.reject({
        code: type_1.UserErrCode.ERR_NO_JSAPI,
        msg: 'should add apiJs - browser.login.getAccountInfo',
    });
};
